import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Textarea,
  Text,
  AlertStatus,
} from '@chakra-ui/react';
import ModalHeaderComponent from '../../../components/ModalHeader';
import { useEffect, useRef, useState } from 'react';
import { getDateAndTimeInterval, normalizeDate } from '../../../components/Format';
import { requestServerApi, serverApi } from '../../../api/api';
import useErrorPage from '../../../hooks/useErrorPage/useErrorPage';
import useAppToast from '../../../hooks/useAppToast/useAppToast';

type Props = {
  onClose: () => void;
  setRefreshFlg: (flg: boolean) => void;
  start_datetime: string;
  end_datetime: string;
  note: string;
  company_id: string;
  lesson_id: string;
};

export default function NoteEditModal({
  onClose,
  setRefreshFlg,
  start_datetime,
  end_datetime,
  note,
  company_id,
  lesson_id,
}: Props) {
  const [confirming, setConfirming] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [newNote, setNewNote] = useState<string>(note || '');
  const { apiErrorHandler } = useErrorPage();
  const { displayToast } = useAppToast();

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (!confirming) {
      setTimeout(() => {
        textareaRef.current?.focus();
      }, 0);
    }
  }, [confirming]);

  const closeModal = () => {
    onClose();
  };

  const handleInputChange = (e: any) => {
    setNewNote(e.target.value);
  };

  // 更新処理
  const onNoteUpdate = () => {
    setUpdating(true);
    const apiResponse = requestServerApi<any>(() =>
      serverApi
        .organizationsControllerUpdateLessonNote(String(company_id), lesson_id, {
          note: newNote,
        })
        .catch((e) =>
          apiErrorHandler(e, {
            componentName: 'lesson_notes',
            functionName: serverApi.organizationsControllerUpdateLessonNote.name,
          }),
        ),
    );
    apiResponse.then((data: any) => {
      reactToUpdation(data.data.message, '申し送り事項更新');
      closeModal();
      setRefreshFlg(true);
    });
  };

  //　更新後の処理
  const reactToUpdation = (msg: string, toastTitle: string) => {
    var toastDescription: string =
      msg === 'NO_ERROR' ? `${toastTitle}をしました。` : `${toastTitle}に失敗しました。`;
    var toastStatus: AlertStatus = msg === 'NO_ERROR' ? 'success' : 'error';
    setTimeout(() => {
      closeModal();
      displayToast(toastTitle, toastDescription, toastStatus);
    }, 1000);
  };

  return (
    <Modal isOpen={true} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent minW="55rem">
        <ModalHeaderComponent title={!confirming ? '申し送り編集' : '申し送り編集　確認'} />
        <ModalBody>
          <Flex direction={'column'}>
            <Text fontWeight={'bold'}>日時</Text>
            <Text>{getDateAndTimeInterval(start_datetime, end_datetime)}</Text>
          </Flex>

          <Box mt={5} mb={2} overflowY="auto">
            <Text fontWeight={'bold'}>内容</Text>
          </Box>
          {confirming ? (
            <Box mt={2} whiteSpace="pre-wrap">
              {newNote || '申し送りが入力されていません'}
            </Box>
          ) : (
            <Textarea
              ref={textareaRef}
              placeholder="申し送りを入力してください。。"
              onChange={handleInputChange}
              value={newNote}
            />
          )}
        </ModalBody>
        <ModalFooter>
          {confirming === false ? (
            <Flex justifyContent="right">
              <Button
                colorScheme="teal"
                mr={3}
                onClick={() => setConfirming(true)}
                disabled={updating || newNote === note}
              >
                確認
              </Button>
              <Button colorScheme="gray" onClick={closeModal}>
                キャンセル
              </Button>
            </Flex>
          ) : (
            <Flex justifyContent="right">
              <Button colorScheme="teal" mr={3} onClick={() => onNoteUpdate()} disabled={updating}>
                確定
              </Button>
              <Button colorScheme="gray" onClick={() => setConfirming(false)} disabled={updating}>
                修正
              </Button>
            </Flex>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
